import { render, staticRenderFns } from "./CombinationDetail.vue?vue&type=template&id=45b2a1ec"
import script from "./CombinationDetail.vue?vue&type=script&lang=js"
export * from "./CombinationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports